import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import InputWrapper from "../InputWrapper";
import style from "../../../assets/css/styles.module.scss";

require("react-datepicker/dist/react-datepicker.min.css");

const DateInput = ({
  onChange,
  value,
  dateFormat,
  placeholder,
  disabled,
  required,
  id,
  errorMsg,
  className,
  isValid,
  name,
  label,
  afterInputText,
  minDate,
  maxDate
}) => {
  const applyChange = date => {
    const event = { target: { value: date } };
    onChange(event);
  };

  return (
    <InputWrapper
      className={className}
      isValid={isValid}
      errorMsg={errorMsg}
      label={label}
      afterInputText={afterInputText}
    >
      <DatePicker
        id={id}
        name={name}
        autoComplete="off"
        dateFormat={dateFormat}
        onChange={applyChange}
        selected={value}
        className={isValid === false ? style.inputError : ""}
        popperClassName={style.datePickerPopper}
        placeholderText={placeholder}
        disabled={disabled}
        required={required}
        maxDate={maxDate}
        minDate={minDate}
      />
    </InputWrapper>
  );
};

DateInput.displayName = "DateInput";

DateInput.defaultProps = {
  id: "",
  name: "",
  value: null,
  dateFormat: "dd/MM/yyyy",
  errorMsg: null,
  onChange: () => {},
  placeholder: "",
  className: null,
  disabled: false,
  required: false,
  isValid: null,
  label: null,
  afterInputText: null,
  minDate: "",
  maxDate: ""
};

DateInput.propTypes = {
  /** Date id */
  id: PropTypes.string,
  /** Date id */
  name: PropTypes.string,
  /** Date value */
  value: PropTypes.object,
  /** Format of the date */
  dateFormat: PropTypes.string,
  /** Add disabled to the component */
  disabled: PropTypes.bool,
  /** Add required to the component */
  required: PropTypes.bool,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Date validation error message */
  errorMsg: PropTypes.string,
  /** Date placeHolder */
  placeholder: PropTypes.string,
  /** Add className to the component */
  className: PropTypes.string,
  /** Is Date valid */
  isValid: PropTypes.bool,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** minimum for date */
  minDate: PropTypes.string,
  /** maximum for date */
  maxDate: PropTypes.string
};

export default DateInput;
